import {
  REGISTER_TRIAL_USER,
  REGISTER_TRIAL_USER_SUCCESSFUL,
  REGISTER_TRIAL_USER_FAILED,
  GET_NEW_TRIAL_USER,
  GET_TRIAL_USER_FAILED,
  GET_TRIAL_USER_SUCCESSFUL,
  UPDATE_TRIAL_USER_SUCCESSFUL,
  DELETE_TRIAL_USER,
  DELETE_TRIAL_USER_SUCCESSFUL,
} from "./actionTypes";

const initialState = {
  userError: null,
  message: null,
  loading: null,
  isLoaded: false,
  isLoading: false,
  accounts: null,
  company: "",
  firstName: "",
  lastName: "",
  email: "",
  cloudAccounts: "",
  numberOfUsers: "",
  scanFreq: "",
  compliance: "",
  expDate: "",
  regType: "",
  comments: "",
  datas: {},
};

function trialuser(state = initialState, action) {
  switch (action.type) {
    case REGISTER_TRIAL_USER:
      state = {
        loading: true,
        userError: null,
        message: null,
      };
      break;

    case REGISTER_TRIAL_USER_SUCCESSFUL:
      // console.log(action.payload.user.company)
      state = {
        message: action.payload.toString(),
        company: action.payload.user.company,
        loading: false,
        userError: null,
      };
      break;

    case REGISTER_TRIAL_USER_FAILED:
      state = {
        ...state,
        loading: false,
        message: action.payload.response.data,
        userError: action.payload.response.status,
      };
      break;

    case GET_NEW_TRIAL_USER:
      state = {
        ...state,
        isLoading: true,
        //Added the following for spinner
        loading: true,
      };
      break;

    case GET_TRIAL_USER_SUCCESSFUL:
      console.log("payload = ", action.payload);
      console.log("users = ", Object.values(action.payload.user));
      const users = action.payload.user.data;
      const usersWithIds = users.map((user, index) => {
        // Use the index as the unique id for each user object
        return { ...user, id: user.key };
      });
      state = {
        ...state,
        isLoading: false,
        //Added for spinner
        loading: false,
        isLoaded: true,
        users: usersWithIds,
        userError: null,
      };
      break;

    case GET_TRIAL_USER_FAILED:
      state = {
        ...state,
        loading: false,
        message: action.payload.response.data,
        userError: action.payload.response.status,
      };
      break;
    case UPDATE_TRIAL_USER_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        updateTrailUserStatus: action.payload.user,
      };
      break;
    case DELETE_TRIAL_USER_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        deleteTrialUserStatus: action.payload.user,
      };
    default:
      state = { ...state };
      break;
  }
  return state;
}

export default trialuser;
